<template>
    <div class="exit">
        <div>
            <div>
                <span>头像</span>
            </div>
            <div class="portrait">
                <img src="../assets/pic.png" alt="">
                <span class="iconfont icon-xiangyou-copy"></span>
            </div>
        </div>
        <div>
            <div>
                <span>昵称</span>
            </div>
            <div>
                <span>{{mobile}}</span>
                <span class="iconfont icon-xiangyou-copy"></span>
            </div>
        </div>
        <div>
            <div>
                <span>手机号</span>
            </div>
            <div>
                <span>{{mobile}}</span>
                <span class="iconfont icon-xiangyou-copy"></span>
            </div>
        </div>
        <div class="exitbt" @click="exit">
            <span>退出当前账号</span>
        </div>
    </div>
</template>

<script>
import common from "../common";
export default {
    name: 'exit',
    data () {
        return {
            mobile:""
        }
    },
    methods: {
        exit(){
            //统一清除 localStorage + cookie 登录状态
            common.clearUserInfo();
            this.$router.push("login");
        }
    },
    created() {
        //读取登录状态：localStorage 优先，cookie 兜底
        let userInfo=common.getUserInfo();
        if(userInfo){
            this.mobile=userInfo.mobile;
        }else{
            this.$router.replace({ name: 'login'});
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.exit{
    padding-top: 30px;
}
.exit>div{
    margin: 0 auto;
    width: 676px;
    height: 100px;
    padding: 10px 0;
    display: -webkit-flex;
    border-bottom: 1px solid #e7e7e7;
    justify-content: space-between;
    align-items: center;
    color: #999999;
    font-size: 35px;
}
img{
    width: 90px;
    margin-right: 30px;
}
.portrait{
    display: -webkit-flex;
    align-items: center;
}
.exit>.exitbt{
    width: 676px;
    margin: 100px auto;
    height: 60px;
    background: #0097fe;
    border-radius: 10px;
    color: white;
    justify-content: center;
}
</style>
      


// WEBPACK FOOTER //
// src/components/exit.vue